import React, { useState, useEffect, lazy, Suspense } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./CalenderEvent.css";

const FullCalendar = lazy(() => import("@fullcalendar/react"));
const dayGridPlugin = lazy(() => import("@fullcalendar/daygrid"));
const interactionPlugin = lazy(() => import("@fullcalendar/interaction"));

function CalenderEvent() {
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json",
  };

  // Fetch Events from API
  useEffect(() => {
    async function fetchEvents() {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_Baseurl}/admin/advertisement/calendar-event`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();
          // const eventList = data.advertisements.flatMap((ad) =>
          //   ad.AdsEvents.map((event) => ({
          //     id: event.id,
          //     title: `${ad.ads_name.slice(0, 5)}...`, // Shortened name
          //     start: new Date(event.start_timestamp),
          //     end: new Date(event.end_timestamp),
          //   }))
          // );

          // setEvents(eventList);
        } else {
          console.error("Failed to fetch events");
        }
      } catch (error) {
        console.error(error);
      }
    }

    fetchEvents();
  }, []);


  // Static test data
  const [advertisements, setTest] = useState([
    {
      id: 2,
      ads_name: "Manikandan ads test  1",
      ads_slug: "Manikandan-ads-test-1",
      ads_position: "pre",
      AdsEvents: [
        {
          start_timestamp: "2024-12-12T21:30:19.000Z",
          end_timestamp: "2024-12-14T21:30:19.000Z",
          status: 0,
        },
        {
          start_timestamp: "2024-12-15T21:30:19.000Z",
          end_timestamp: "2024-12-16T21:30:19.000Z",
          status: 0,
        },
      ],
    },
    {
      id: 5,
      ads_name: "Manikandan ads test  1",
      ads_slug: "Manikandan-ads-test-1",
      ads_position: "pre",
      AdsEvents: [
        {
          start_timestamp: "2024-12-12T21:30:19.000Z",
          end_timestamp: "2024-12-14T21:30:19.000Z",
          status: 0,
        },
        {
          start_timestamp: "2024-12-15T21:30:19.000Z",
          end_timestamp: "2024-12-16T21:30:19.000Z",
          status: 0,
        },
        {
          start_timestamp: "2024-12-15T21:30:19.000Z",
          end_timestamp: "2024-12-16T21:30:19.000Z",
          status: 0,
        },
        {
          start_timestamp: "2024-12-15T21:30:19.000Z",
          end_timestamp: "2024-12-16T21:30:19.000Z",
          status: 0,
        },
        {
          start_timestamp: "2024-12-15T21:30:19.000Z",
          end_timestamp: "2024-12-16T21:30:19.000Z",
          status: 0,
        },
        {
          start_timestamp: "2024-12-15T21:30:19.000Z",
          end_timestamp: "2024-12-16T21:30:19.000Z",
          status: 0,
        },
        {
          start_timestamp: "2024-12-15T21:30:19.000Z",
          end_timestamp: "2024-12-16T21:30:19.000Z",
          status: 0,
        },
        {
          start_timestamp: "2024-12-15T21:30:19.000Z",
          end_timestamp: "2024-12-16T21:30:19.000Z",
          status: 0,
        },
      ],
    },
    {
      id: 6,
      ads_name: "Manikandan ads test  1",
      ads_slug: "Manikandan-ads-test-1",
      ads_position: "pre",
      AdsEvents: [
        {
          start_timestamp: "2024-12-12T21:30:19.000Z",
          end_timestamp: "2024-12-14T21:30:19.000Z",
          status: 0,
        },
        {
          start_timestamp: "2024-12-15T21:30:19.000Z",
          end_timestamp: "2024-12-16T21:30:19.000Z",
          status: 0,
        },
      ],
    },
  ]);

  React.useEffect(() => {
    // Generate events from static data
    const eventList = advertisements.flatMap((ad) =>
      ad.AdsEvents.map((event) => ({
        id: event.id,
        title: `${ad.ads_name.slice(0, 5)}...`, // Shortened name
        start: new Date(event.start_timestamp),
        end: new Date(event.end_timestamp),
      }))
    );

    setEvents(eventList); // Set events for FullCalendar
  }, [advertisements]);

  // Handle Event Click
  const handleEventClick = (info) => {
    setSelectedEvent(info.event);
    setShowModal(true);
  };

  // Handle Delete Confirmation
  const handleDeleteConfirmation = async () => {
    try {
      const eventId = selectedEvent.extendedProps.id;
      const response = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/advertisement/calendar-event-delete/${eventId}`,
        { method: "DELETE", headers }
      );
      if (response.ok) {
        setEvents((prevEvents) =>
          prevEvents.filter((event) => event.id !== eventId)
        );
      } else {
        console.error("Failed to delete event");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowModal(false);
      setSelectedEvent(null);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <h3>Calendar Events</h3>
        <Suspense fallback={<div className="text-center py-4">Loading Calendar...</div>}>
          <FullCalendar
            plugins={[dayGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            events={events}
            eventContent={(arg) => (
              <div style={{ fontSize: "10px", textAlign: "center" }}>
                {arg.event.title}
              </div>
            )}
            eventClick={handleEventClick}
          />
        </Suspense>

      </div>

      {/* Modal for Delete Confirmation */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this event:{" "}
          {selectedEvent?.title || "this event"}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirmation}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CalenderEvent;
